import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Typography } from '@repo/ui/Typography';
type OptionCardContentProps = {
  iconHTML?: string;
  label: string;
  description?: string;
};
type OptionLabelProps = {
  label: string;
  description?: string;
};
function OptionLabel(t0) {
  const $ = _c(13);
  const {
    label,
    description
  } = t0;
  if (!description) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        flex: "[1]"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== label) {
      t2 = <Typography as="span" variant="body" css={t1}>{label}</Typography>;
      $[1] = label;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      display: "flex",
      flexDirection: "column",
      gap: "1",
      flex: "[1]"
    });
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontWeight: "bold"
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label) {
    t3 = <Typography as="span" variant="body" css={t2}>{label}</Typography>;
    $[5] = label;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== description) {
    t4 = <Typography as="span" variant="body">{description}</Typography>;
    $[7] = description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = <span className={t1}>{t3}{t4}</span>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
export function OptionCardContent(t0) {
  const $ = _c(8);
  const {
    iconHTML,
    label,
    description
  } = t0;
  let t1;
  if ($[0] !== iconHTML) {
    t1 = iconHTML && <span className={css({
      flexShrink: "[0]",
      fontSize: "[20px]",
      width: "[28px]",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    })} aria-hidden="true" dangerouslySetInnerHTML={{
      __html: iconHTML
    }} />;
    $[0] = iconHTML;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== description || $[3] !== label) {
    t2 = <OptionLabel label={label} description={description} />;
    $[2] = description;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}